export function trackEvent(eventName, params = {}) {
  if (typeof window === 'undefined' || !eventName) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...params
  });

  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
}

export function trackContactClick(channel) {
  trackEvent('contact_clicked', {
    contact_channel: channel
  });
}

export function trackSignupClick(source) {
  trackEvent('signup_cta_clicked', {
    signup_source: source
  });
}
